import type { FC } from 'react';
import { useNavigate } from 'react-router';

import { Button } from 'ui';

import classes from '../Registration/register.module.scss';

// Figma 21:8271 «Пароль обновлен»: заголовок, подзаголовок и одна кнопка «Войти».
export const ResetSuccess: FC = () => {
  const navigate = useNavigate();

  return (
    <section className={classes.wrapper}>
      <main className={classes.container}>
        <div className={classes.form}>
          <div className={classes.heading}>
            <h1 className={classes.title}>Пароль обновлен</h1>
            <p className={classes.subtitle}>Теперь вы можете войти с новым паролем.</p>
          </div>

          <Button
            variant='filled'
            shape='brick'
            widthFullSize
            className={classes.submitButton}
            onClick={() => navigate('/login')}
          >
            Войти
          </Button>
        </div>
      </main>
    </section>
  );
};
